import React, { useEffect, useState } from "react";
import Message from "./Message";
import { Col, Row, Button, Form } from "react-bootstrap";
import {
  FaCalculator,
  FaCashRegister,
  FaCheckCircle,
  FaEdit,
  FaRegClock,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import axios from "axios";
import { IoLogInOutline } from "react-icons/io5";
import { SlBasket } from "react-icons/sl";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { RiCalendarCheckFill } from "react-icons/ri";
import MyLines from "./MyLines";
import { GoSync } from "react-icons/go";

const VisitSecretarySection = ({
  visit,
  visitDate,
  setVisitDate,
  setVisitTime,
  setVisitDay,
  visitDay,
  visitTime,
  clinic,
}) => {
  const [visitServices, setVisitServices] = useState(
    visit.secretarySection.visitServices,
  );
  const [paid, setPaid] = useState(visit.secretarySection.paid);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [remaining, setRemaining] = useState(0);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const secretary = visit?.secretarySection?.secretaryDetails;

  const dispatch = useDispatch();

  const updateServices = async () => {
    if (!visitDate || visitServices.length === 0 || !paid) {
      notify({
        title: "Register Err",
        message: <p className="lead">All inputs are required.</p>,
        type: "Danger",
        duration: 3000,
      });
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visit._id}/updateVisitSecretarySection`,
        {
          visitServices,
          paid,
          visitDate,
        },
        config,
      );
      // console.log(data);
      setVisitDate(data.updatedVisitDate);
      setVisitServices(data.updatedVisitServices);
      setPaid(data.updatedPaid);
      setLoading(false);
      setShowEdit(false);
      notify({
        title: "Services Update",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };

  useEffect(() => {
    const date =
      visitDay && visitTime ? new Date(`${visitDay}T${visitTime}`) : false;
    setVisitDate(date ? date.toISOString() : ""); // يضمن نفس القيم في جميع الأجهزة
  }, [visitDay, visitTime]);

  // Select / unselect service
  const handleServiceChange = (service, checked) => {
    if (checked) {
      setVisitServices((prev) => {
        if (prev.some((item) => item.serviceId === service._id)) {
          return prev;
        }

        return [
          ...prev,
          {
            idx: Math.random(),
            serviceId: service._id,
          },
        ];
      });
    } else {
      setVisitServices((prev) =>
        prev.filter((item) => item.serviceId !== service._id),
      );
    }
  };

  useEffect(() => {
    // Calculate remaining
    setRemaining(totalAmount - Number(paid || 0));
  }, [, paid, totalAmount]);

  useEffect(() => {
    // Calculate total
    setTotalAmount(
      (clinic?.clinicServices || [])
        .filter((service) =>
          visitServices?.some((item) => item.serviceId === service._id),
        )
        .reduce((total, service) => total + Number(service.price || 0), 0),
    );
  }, [visitServices]);

  useEffect(() => {}, [showEdit]);
  return (
    <>
      <h4
        className="text-center text-white p-3"
        style={{ backgroundColor: "#9FA6B2" }}
      >
        {" "}
        <IoLogInOutline /> Receiption Section
      </h4>
      {showEdit ? (
        <>
          <Row className="flex-row-reverse px-1 text-center">
            <Col xs={12} md={12} lg={6}>
              <Form.Group controlId="visitDay">
                <Form.Label>
                  يوم الزيارة <RiCalendarCheckFill />
                </Form.Label>
                <Form.Control
                  className="text-center"
                  type="date"
                  value={visitDay}
                  onChange={(e) => setVisitDay(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <Form.Group controlId="visitTime">
                <Form.Label>
                  وقت الزيارة <FaRegClock />
                </Form.Label>
                <Form.Control
                  className="text-center"
                  type="time"
                  value={visitTime}
                  onChange={(e) => setVisitTime(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <MyLines type="dashed" />
          {/* ================= SERVICES =================  */}
          <Row className="mt-2 text-center">
            <Col xs={12}>
              <Form.Label className="fw-bold d-block mb-3">
                <SlBasket /> اختر الخدمات
              </Form.Label>

              <Row className="justify-content-center g-2">
                {clinic?.clinicServices?.filter((s) => !s.isHide).length > 0 ? (
                  clinic.clinicServices
                    .filter((s) => !s.isHide)
                    .map((service) => {
                      const isSelected = visitServices?.some(
                        (item) => item.serviceId === service._id,
                      );

                      return (
                        <Col
                          onClick={(e) =>
                            handleServiceChange(service, e.target.checked)
                          }
                          key={service._id}
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          xl={2}
                        >
                          <div
                            className={`border rounded p-2 h-100 ${
                              isSelected ? "border-primary bg-light" : ""
                            }`}
                          >
                            <Form.Check
                              type="checkbox"
                              id={`service-${service._id}`}
                              checked={isSelected}
                              label={
                                <span className="d-block text-center">
                                  {service.label}
                                  <br />
                                  <small className="text-muted">
                                    {service.price}
                                  </small>
                                </span>
                              }
                            />
                          </div>
                        </Col>
                      );
                    })
                ) : (
                  <Col xs={12}>
                    <div className="text-muted py-3">لا توجد خدمات</div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
          <MyLines type="dashed" />

          {/* ================= PAYMENT ================= */}
          <Row className="justify-content-center flex-row-reverse text-center mt-4 g-3">
            {/* Total */}
            <Col xs={12} sm={6} md={4} lg={3}>
              <Form.Group controlId="totalAmount">
                <Form.Label>
                  <FaCalculator /> الإجمالي
                </Form.Label>

                <Form.Control
                  type="number"
                  className="text-center fw-bold"
                  value={totalAmount}
                  readOnly
                />
              </Form.Group>
            </Col>

            {/* Paid */}
            <Col xs={12} sm={6} md={4} lg={3}>
              <Form.Group controlId="paid">
                <Form.Label>
                  <FaCashRegister /> المدفوع
                </Form.Label>

                <Form.Control
                  type="number"
                  value={paid}
                  min="0"
                  max={totalAmount}
                  className="text-center"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "" || Number(value) <= totalAmount) {
                      setPaid(value);
                    }
                  }}
                />
              </Form.Group>
            </Col>

            {/* Remaining */}
            <Col xs={12} sm={6} md={4} lg={3}>
              <Form.Group controlId="remaining">
                <Form.Label>
                  {" "}
                  <FaHandHoldingDollar /> المتبقي
                </Form.Label>

                <Form.Control
                  type="number"
                  className="text-center fw-bold"
                  value={remaining}
                  readOnly
                  isInvalid={remaining < 0 && true}
                />
              </Form.Group>
            </Col>
          </Row>
          {/* ================= SUBMIT ================= */}

          {error && (
            <Message
              children={`Update Visit Err: ${error}`}
              variant={`danger`}
              setMessage={setError}
            />
          )}

          <Row className="mt-4">
            <Col xs={12} className="text-center">
              <Button
                style={{ backgroundColor: "#00abff", border: "none" }}
                className="w-100 w-md-auto px-5"
                onClick={() => updateServices()}
              >
                تحديث البيانات <GoSync />
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        //  DISPLAY === showEdit is false
        <>
          {visitServices.length > 0 && (
            <Row className="mt-3  ">
              <Col xs={12}>
                <div>
                  <h6 className="text-center">الخدمات المختارة</h6>

                  {visitServices.map((selectedService) => {
                    const service = clinic?.clinicServices?.find(
                      (item) => item._id === selectedService.serviceId,
                    );

                    if (!service) {
                      return null;
                    }

                    return (
                      <div
                        key={selectedService.idx}
                        className="d-flex flex-row-reverse text-center text-primary border-bottom py-2"
                      >
                        <Col>
                          <span>
                            {service.label} <FaCheckCircle />
                          </span>
                        </Col>
                        <Col>
                          {" "}
                          <span>{Number(service.price || 0)}</span>
                        </Col>
                      </div>
                    );
                  })}

                  <div className="d-flex border-bottom pb-2 flex-row-reverse text-center fw-bold mt-2">
                    <Col>
                      {" "}
                      <span>الإجمالي</span>
                    </Col>
                    <Col>
                      {" "}
                      <span>{totalAmount}</span>
                    </Col>
                  </div>
                  <div className="d-flex border-bottom pb-2 flex-row-reverse text-center fw-bold mt-2">
                    <Col>
                      {" "}
                      <span>المدفوع</span>
                    </Col>
                    <Col>
                      {" "}
                      <span>{paid}</span>
                    </Col>
                  </div>
                  <div className="d-flex  flex-row-reverse text-center fw-bold mt-2">
                    <Col>
                      {" "}
                      <span>المتبقي</span>
                    </Col>
                    <Col>
                      {" "}
                      <span>{remaining}</span>
                    </Col>
                  </div>
                </div>
              </Col>
            </Row>
          )}
          <div className="text-center mt-3 p-3 bg-light rounded border small text-muted">
            <div className="mb-2">
              <strong className="text-dark">
                {secretary?.firstName} {secretary?.lastName}
              </strong>{" "}
              <span>تم التسجيل بواسطة </span>
            </div>

            <Row className="justify-content-center gap-3 flex-wrap mb-3 g-0">
              <Col className="col-auto">
                <span
                  onClick={() => setShowEdit(true)}
                  className="fw-semibold text-primary"
                >
                  <FaEdit className="me-1" /> تعديل
                </span>
              </Col>
              <Col className="col-auto">
                <span className="fw-semibold">آخر تحديث: </span>
                {new Date(visit.secretarySection.updatedAt).toLocaleString(
                  "ar-EG",
                )}
              </Col>
              <Col className="col-auto">
                <span className="fw-semibold">تاريخ الإنشاء: </span>
                {new Date(visit.secretarySection.createdAt).toLocaleString(
                  "ar-EG",
                )}
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
};

export default VisitSecretarySection;
